import React from "react";
import { connect } from "react-redux";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import { Button, FontIcon } from "react-md";
import {map, isEmpty, size} from "lodash";

import Carousel from "../Carousel";
import AtollonLogo from "../../assets/img/atollon-thumb.png";
import {TouchOrganizations} from "../../Atollon/Organizations";
import {TouchGreyBackgroundWithBorder, TouchTableHeader} from "../../AtollonTheme/ReactElements";

const Suppliers = ({ history, providers }) => {
  return (
      <div>

          <TouchTableHeader
              title={"Moji dodavatelé"}
              titleNumber={providers && !isEmpty( providers.item ) ? size( providers.item ) : null}
              titleButtons={(
                  <Button
                      raised
                      className="btn btn-primary touchButton-4 touchButton-shape3"
                      label="Pozvat dodavatele"
                      onClick={() => history.push("/suppliers-invite")}
                  />
              )}
          />

          <TouchGreyBackgroundWithBorder>
              {providers && providers.item && !isEmpty(providers.item) ? (
                      <div>
                          <TouchOrganizations
                              gotoAdminPage={false}
                              organizationArray={providers.item}
                              history={history}
                          />
                      </div>
              ) : null
              }
          </TouchGreyBackgroundWithBorder>

    </div>
  );
};

export default connect(({ resource: { providers } }) => ({ providers }), null)(
  Suppliers
);



// WEBPACK FOOTER //
// ./src/components/main/Suppliers.js